'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

const trachtNhiem = [
  'giữ hình ảnh cá nhân phù hợp với tinh thần chương trình',
  'chia sẻ đúng trải nghiệm, không truyền thông sai lệch hoặc phóng đại',
  'tham gia các hoạt động đã xác nhận với tinh thần trách nhiệm',
  'tôn trọng định hướng truyền thông và nguyên tắc làm việc chung',
  'không sử dụng danh nghĩa Ambassador vào các mục đích không phù hợp',
];

export default function Slide25bFlexBenefits({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0a1a0f]">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_171aa2e57-1774901432383.png"
          alt="Nhóm tình nguyện viên sinh viên Việt Nam cùng nhau làm việc vì cộng đồng"
          className="w-full h-full object-cover opacity-8"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a1a0f]/95 via-[#1a3a2a]/60 to-[#0a1a0f]/95" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-16 min-h-screen flex flex-col justify-center">
        {/* Header */}
        <div className="fade-in-up mb-8 text-center">
          <p className="font-display font-600 text-[clamp(11px,1.4vw,14px)] text-[#4caf7d] uppercase tracking-[0.15em] mb-2">
            Student Ambassador
          </p>
          <h2 className="font-display font-800 text-[clamp(22px,3.5vw,44px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            Trách nhiệm của Student Ambassador
          </h2>
          <div className="w-[60px] h-[3px] bg-gradient-to-r from-[#4caf7d] to-[#a8d87a] rounded-full mx-auto mt-4" />
        </div>

        <div className="max-w-3xl mx-auto w-full fade-in-up">
          <p className="font-body text-[14px] text-[#a0b8a8] leading-relaxed mb-8 text-center">
            Song song với quyền lợi, Student Ambassador cần:
          </p>

          <div className="space-y-4">
            {trachtNhiem.map((item, i) => (
              <div
                key={i}
                className="rounded-2xl border border-[rgba(76,175,125,0.2)] bg-[rgba(76,175,125,0.05)] p-5 flex items-start gap-4 transition-all duration-300 hover:-translate-y-0.5"
              >
                <div className="w-8 h-8 rounded-full bg-[rgba(76,175,125,0.15)] border border-[rgba(76,175,125,0.3)] flex items-center justify-center flex-shrink-0">
                  <span className="font-display font-700 text-[13px] text-[#4caf7d]">{i + 1}</span>
                </div>
                <p className="font-body text-[14px] text-[#c0d8c0] leading-relaxed">{item}</p>
              </div>
            ))}
          </div>

          {/* Closing note */}
          <div className="mt-8 rounded-2xl bg-gradient-to-r from-[rgba(76,175,125,0.12)] to-[rgba(168,216,122,0.06)] border border-[rgba(76,175,125,0.25)] p-6 text-center">
            <p className="font-display font-700 text-[16px] text-[#f0ede6] mb-2">
              Đồng hành có trách nhiệm — Lan tỏa có giá trị
            </p>
            <p className="font-body text-[13px] text-[#a0b8a8] leading-relaxed">
              Tri An Green Travel mong muốn xây dựng một cộng đồng Ambassador gần gũi, chân thật và bền vững cùng sinh viên.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 pt-4 border-t border-[rgba(76,175,125,0.1)] flex flex-col sm:flex-row items-center justify-center gap-4 fade-in-up">
          <span className="font-body text-[11px] text-[#a0b8a8]/60 uppercase tracking-wider">HOTLINE: 0827092079</span>
          <span className="hidden sm:block text-[#a0b8a8]/30">|</span>
          <span className="font-body text-[11px] text-[#a0b8a8]/60 uppercase tracking-wider">EMAIL: triangreentravel@gmail.com</span>
        </div>
      </div>
    </SlideWrapper>
  );
}